export default "__VITE_ASSET__BXo9GsJX__"